import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/tv-shows';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-xl text-white"></i>
            </div>
            <span className={`font-heading text-xl font-bold transition-colors ${
              isScrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              老子影视网
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-white'
                    : isScrolled
                      ? 'text-foreground-700 hover:bg-background-200 hover:text-foreground-900'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <button
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm'
              }`}
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索</span>
            </button>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-2xl ${isScrolled ? 'text-foreground-800' : 'text-white'} ${
              isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
            }`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  (cat.slug === 'all' && location.pathname === '/') || location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} text-lg`}></i>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-200/70 my-2"></div>
            <Link
              to="/about"
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}